import { formatMoney } from "./currencyFormat";
export const sideBarData = [
  // Order: stakeholder module list (Dashboard → Support), then Financial Management (not on stakeholder sheet; keeps Transaction History in nav).
  {
    name: "Dashboard",
    path: "/super_admin/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
  },
  {
    name: "Audit log",
    path: "/super_admin/audit_log",
    image1: "/Images/sidebar/Note.svg",
    image: "/Images/sidebar/Note.svg",
    dropDown: "none",
  },
  {
    name: "Configuration & Settings",
    path: "/super_admin/settings",
    image: "/Images/sidebar/settings.svg",
    image1: "/Images/sidebar/settings1.svg",
    subMenu: [
      {
        name: "Portal Settings",
        path: "/super_admin/settings/portal_settings",
      },
      {
        name: "Branch Management",
        path: "/super_admin/settings/branch_management",
      },
      {
        name: "Member slot capacity",
        path: "/super_admin/settings/member_slot_capacity",
      },
      {
        name: "Company Prefix",
        path: "/super_admin/settings/company_prefix",
      },
      {
        name: "Society Bank Info",
        path: "/super_admin/settings/society_bank_info",
      },
      {
        name: "Member Registration Fee",
        path: "/super_admin/settings/member_registration_fee",
      },
      {
        name: "Loan Application Setting",
        path: "/super_admin/settings/loan_application_settings",
      },
      {
        name: "Role Management",
        path: "/super_admin/settings/role_management",
      },
      {
        name: "Fine Setting",
        path: "/super_admin/settings/fine_settings",
      },
      {
        name: "Support Settings",
        path: "/super_admin/settings/support_settings",
      },
    ],
  },
  {
    name: "Member Management",
    path: "/super_admin/member_management",
    image: "/Images/sidebar/Employee.svg",
    image1: "/Images/sidebar/Employee1.svg",
    subMenu: [
      {
        name: "Member Registration",
        path: "/super_admin/member_management",
      },
      {
        name: "View Member (s)",
        path: "/super_admin/member_management/members",
      },
      {
        name: "Pending Member",
        path: "/super_admin/member_management/pending_member",
      },
      {
        name: "Archived Members",
        path: "/super_admin/member_management/archived_members",
      },
      {
        name: "Exit Requests",
        path: "/super_admin/member_management/exit_requests",
      },
      {
        name: "Exited Members",
        path: "/super_admin/member_management/exited_members",
      },
      {
        name: "Batch Upload",
        path: "/super_admin/member_management/batch_upload",
      },
    ],
  },
  {
    name: "Staff Management",
    path: "/super_admin/staff_registration",
    image: "/Images/sidebar/Staff management.svg",
    image1: "/Images/sidebar/Staff management1.svg",
    subMenu: [
      {
        name: "Staff Registration",
        path: "/super_admin/staff_registration",
      },
      {
        name: "View Staff",
        path: "/super_admin/staff_registration/view_staff",
      },
      {
        name: "Batch Upload",
        path: "/super_admin/staff_registration/batch_upload",
      },
    ],
  },
  {
    name: "Contribution Management",
    path: "/super_admin/contribution",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    subMenu: [
      {
        name: "Record a payment",
        path: "/super_admin/contribution/record_contribution",
        aliases: ["record contribution", "add contribution", "new contribution"],
      },
      {
        name: "All payments",
        path: "/super_admin/contribution/contribution_history_v2",
        aliases: ["contribution summary", "summary", "ledger", "transactions", "report", "download"],
      },
      {
        name: "Totals by category",
        path: "/super_admin/contribution/contribution_history",
        aliases: ["contribution history", "history", "category totals"],
      },
      {
        name: "Withdrawals",
        path: "/super_admin/contribution/withdrawal_requests",
        aliases: ["withdrawal requests", "savings withdrawal", "payout"],
      },
      {
        name: "Confirm bank transfers",
        path: "/super_admin/contribution/bank_transfer_confirmations",
        aliases: ["bank transfer confirmations", "transfer requests"],
      },
      {
        name: "Pending online payments",
        path: "/super_admin/contribution/online_payment_requery",
        aliases: ["online payment requery", "requery", "alatpay", "recheck payment"],
      },
      {
        name: "Branch wallet",
        path: "/super_admin/contribution/branch_settlement_wallet",
        aliases: ["branch settlement wallet", "settlement"],
      },
      {
        name: "Categories",
        path: "/super_admin/contribution/contribution-category",
        aliases: ["contribution category", "types", "setup", "threshold"],
      },
    ],
  },
  {
    name: "Loan Management",
    path: "/super_admin/loan_management",
    image: "/Images/sidebar/Loan Management.svg",
    image1: "/Images/sidebar/Loan Management1.svg",
    subMenu: [
      {
        name: "New Application",
        path: "/super_admin/loan_management/new_application",
      },
      {
        name: "Record Existing Loan",
        path: "/super_admin/loan_management/record_existing_loan",
      },
      {
        name: "Loan Type",
        path: "/super_admin/loan_management/loan_type",
      },
      {
        name: "Loan Calculator",
        path: "/super_admin/loan_management/loan_calculator",
      },
      {
        name: "Loan Status",
        path: "/super_admin/loan_management/loan_status",
      },
      {
        name: "Loan Repayment",
        path: "/super_admin/loan_management/loan_repayment",
      },
      // {
      //   name: "Repayment Settings",
      //   path: "/super_admin/loan_management/repayment_settings",
      // },
    ],
  },
  {
    name: "Marketplace",
    path: "/super_admin/investor_portal/marketplace/dashboard",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    moduleUrl: "marketplace",
    capabilityKey: "marketplace",
    subMenu: [
      {
        name: "Overview",
        path: "/super_admin/investor_portal/marketplace/dashboard",
        capabilityKey: "marketplace",
      },
      {
        name: "Products",
        path: "/super_admin/investor_portal/marketplace/products",
        capabilityKey: "marketplace",
      },
      {
        name: "Categories",
        path: "/super_admin/investor_portal/marketplace/categories",
        capabilityKey: "marketplace",
      },
      {
        name: "Orders",
        path: "/super_admin/investor_portal/marketplace/orders",
        capabilityKey: "marketplace",
      },
    ],
  },
  {
    name: "Communication Management",
    path: "/super_admin/communication",
    image: "/Images/sidebar/antenna.svg",
    subMenu: [
      {
        name: "Summary",
        path: "/super_admin/communication/summary",
      },
      {
        name: "Group Management",
        path: "/super_admin/communication/group_management",
      },
      {
        name: "Communications",
        path: "/super_admin/communication",
      },
    ],
  },
  {
    name: "Event Calendar",
    path: "/super_admin/event_calendar",
    image: "/Images/sidebar/Calendar.svg",
    image1: "/Images/sidebar/Calendar1.svg",
    dropDown: "none",
  },
  {
    name: "Attendance",
    path: "/super_admin/attendance/",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    subMenu: [
      {
        name: "Mark Attendance",
        path: "/super_admin/attendance",
      },
      {
        name: "Attendance History",
        path: "/super_admin/attendance/history",
      },
    ],
  },
  {
    name: "Automated Birthday",
    path: "/super_admin/automated_birthday",
    image: "/Images/sidebar/Automated Birthday.svg",
    image1: "/Images/sidebar/Automated Birthday1.svg",
    dropDown: "none",
  },
  {
    name: "E-Minutes",
    path: "/super_admin/eminutes",
    image: "/Images/sidebar/Timer.svg",
    subMenu: [
      {
        name: "View Minutes",
        path: "/super_admin/eminutes",
      },
      {
        name: "Create Message",
        path: "/super_admin/eminutes/new",
      },
    ],
  },
  {
    name: "Financial Accounting",
    path: "/super_admin/modules/in-development/financial-accounting",
    image: "/Images/sidebar/Calculator.svg",
    image1: "/Images/sidebar/Calculator.svg",
    subMenu: [
      {
        name: "Chart of Account",
        path: "/super_admin/modules/in-development/financial-accounting",
      },
      {
        name: "Journal Entry",
        path: "/super_admin/modules/in-development/financial-accounting",
      },
      {
        name: "Journal Entry History",
        path: "/super_admin/modules/in-development/financial-accounting",
      },
      {
        name: "Report",
        path: "/super_admin/modules/in-development/financial-accounting",
      },
    ],
  },
  {
    name: "Dividend Management",
    path: "/super_admin/modules/in-development/dividend-management",
    image: "/Images/sidebar/briefcase1.svg",
    image1: "/Images/sidebar/briefcase1.svg",
    dropDown: "none",
  },
  {
    name: "Commodities Management",
    path: "/super_admin/modules/in-development/commodities-management",
    image: "/Images/sidebar/Loan Management.svg",
    image1: "/Images/sidebar/Loan Management1.svg",
    dropDown: "none",
  },
  {
    name: "Society Election",
    path: "/super_admin/modules/in-development/society-election",
    image: "/Images/sidebar/Employee.svg",
    image1: "/Images/sidebar/Employee1.svg",
    dropDown: "none",
  },
  {
    name: "Gallery Sharing",
    path: "/super_admin/modules/in-development/gallery-sharing",
    image: "/Images/sidebar/Calendar.svg",
    image1: "/Images/sidebar/Calendar1.svg",
    dropDown: "none",
  },
  {
    name: "Reporting & Analytics",
    path: "/super_admin/reports",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    subMenu: [
      {
        name: "SMS History",
        path: "/super_admin/reports/sms_history",
      },
    ],
  },
  {
    name: "Socio-Services",
    path: "/super_admin/modules/in-development/socio-services",
    image: "/Images/sidebar/antenna.svg",
    image1: "/Images/sidebar/antenna.svg",
    dropDown: "none",
  },
  {
    name: "Other Services",
    path: "/super_admin/modules/in-development/other-services",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Support",
    path: "/super_admin/admin",
    image: "/Images/sidebar/Call Center.svg",
    dropDown: "none",
  },
  {
    name: "Financial Management",
    path: "/super_admin/transaction_history",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    subMenu: [
      {
        name: "Transaction History",
        path: "/super_admin/transaction_history",
      },
    ],
  },
  {
    name: "Investments",
    path: "/super_admin/investor_portal/investments/opportunities",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    moduleUrl: "investment",
    capabilityKey: "investment",
    subMenu: [
      {
        name: "Opportunities",
        path: "/super_admin/investor_portal/investments/opportunities",
        capabilityKey: "investment",
      },
      {
        name: "Investment Requests",
        path: "/super_admin/investor_portal/investments/requests",
        capabilityKey: "investment",
      },
      {
        name: "Participants",
        path: "/super_admin/investor_portal/participants",
        capabilityKey: "investment",
      },
    ],
  },
  {
    name: "Investor Management",
    path: "/super_admin/investor_portal/investors",
    image: "/Images/sidebar/Employee.svg",
    image1: "/Images/sidebar/Employee1.svg",
    moduleUrl: "investor_management",
    capabilityKey: "investorPortal",
    subMenu: [
      {
        name: "Overview",
        path: "/super_admin/investor_portal/dashboard",
        capabilityKey: "investorPortal",
      },
      {
        name: "Investor Accounts",
        path: "/super_admin/investor_portal/investors",
        capabilityKey: "investorPortal",
      },
      {
        name: "KYC Reviews",
        path: "/super_admin/investor_portal/investors/kyc",
        capabilityKey: "investorPortal",
      },
      {
        name: "Website Testimonials",
        path: "/super_admin/investor_portal/website/testimonials",
        capabilityKey: "investorPortal",
      },
    ],
  },
  {
    name: "Real Estate",
    path: "/super_admin/investor_portal/requests/real-estate",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    moduleUrl: "real_estate",
    capabilityKey: "realEstate",
    subMenu: [
      {
        name: "Real Estate Requests",
        path: "/super_admin/investor_portal/requests/real-estate",
        capabilityKey: "realEstate",
      },
      {
        name: "All Service Requests",
        path: "/super_admin/investor_portal/requests",
        capabilityKey: "realEstate",
      },
    ],
  },
];
export const sideBarMemberData = [
  {
    name: "Dashboard",
    path: "/member/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
  },
  {
    name: "Loan Management",
    path: "/member/loan_management",
    image: "/Images/sidebar/Loan Management.svg",
    image1: "/Images/sidebar/Loan Management1.svg",
    dropDown: "none",
    // subMenu:[
    //   {
    //     name:'New Application',
    //     path: "/super_admin/loan_management/new_application",
    //   },
    //   {
    //     name:'Loan Status',
    //     path: "/super_admin/loan_management/loan_status",
    //   },
    //   {
    //     name:'Loan Repayment',
    //     path: "/super_admin/loan_management/loan_repayment",
    //   },
    // ]
  },
  {
    name: "Birthdays",
    path: "/member/birthdays",
    image: "/Images/sidebar/Automated Birthday.svg",
    image1: "/Images/sidebar/Automated Birthday1.svg",
    dropDown: "none",
  },
  {
    name: "Contribution",
    path: "/member/contribution",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
  },
  {
    name: "Transaction History",
    path: "/member/transaction_history",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Messages",
    path: "/member/communication",
    image: "/Icon/message.svg",
    image1: "/Icon/message.svg",
    dropDown: "none",
  },
  {
    name: "Attendance",
    path: "/member/attendance",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Event Calendar",
    path: "/member/event",
    image: "/Images/sidebar/Calendar.svg",
    image1: "/Images/sidebar/Calendar1.svg",
    dropDown: "none",
  },

  {
    name: "Support",
    path: "/member/support",
    image: "/Images/sidebar/Call Center.svg",
    dropDown: "none",
  },

  {
    name: "E-Minutes",
    path: "/member/eminutes",
    image: "/Images/sidebar/Timer.svg",
    dropDown: "none",
  },
  { type: "section", name: "Investments & marketplace" },
  {
    name: "Investment overview",
    path: "/invest/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
  },
  {
    name: "Investments",
    path: "/invest/investments",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
  },
  {
    name: "Marketplace",
    path: "/invest/marketplace",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "My Requests",
    path: "/invest/requests",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
  },
  {
    name: "Investor profile",
    path: "/invest/profile",
    image: "/Images/sidebar/Employee.svg",
    image1: "/Images/sidebar/Employee1.svg",
    dropDown: "none",
  },
];

export const sideBarInvestorData = [
  {
    name: "Dashboard",
    path: "/invest/dashboard",
    image1: "/Images/sidebar/Dashboard.svg",
    image: "/Images/sidebar/Dashboard (1).svg",
    dropDown: "none",
    capabilityKey: "anyInvestorFeature",
  },
  {
    name: "Investments",
    path: "/invest/investments",
    image: "/Images/sidebar/Contribution.svg",
    image1: "/Images/sidebar/Contribution1.svg",
    dropDown: "none",
    capabilityKey: "investment",
  },
  {
    name: "Marketplace",
    path: "/invest/marketplace",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
    capabilityKey: "marketplace",
  },
  {
    name: "My Requests",
    path: "/invest/requests",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
    capabilityKey: "realEstate",
  },
  {
    name: "Notifications",
    path: "/invest/notifications",
    image: "/Images/sidebar/Note.svg",
    image1: "/Images/sidebar/Note1.svg",
    dropDown: "none",
    capabilityKey: "anyInvestorFeature",
  },
  {
    name: "Profile",
    path: "/invest/profile",
    image: "/Images/sidebar/Employee.svg",
    image1: "/Images/sidebar/Employee1.svg",
    dropDown: "none",
    capabilityKey: "investorPortal",
  },
];

export const LoginCarouselData = [
  {
    title: "Collaboration meets Cooperation",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,
    image: `/Images/Login/Frame 41.svg`,
  },
  {
    title: "Growth meets Dedication",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,

    image: "/Images/Login/Frame 41-1.svg",
  },
  {
    title: "Success meets Determination   ",
    desc: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consectetur nunc, erat auctor commodo eu nunc integer nisl arcu. Nunc tempor sit faucibus nibh. Cursus nec placerat urna elementum suscipit arcu purus, feugiat. Viverra eu lacus enim convallis. Integer in metus eget dolor viverra facilisis enim. Non massa tristique bibendum eu condimentum. Eu ullamcorper nulla sit amet mauris.`,
    image: "/Images/Login/Frame 41-2.svg",
  },
];

export const DashboardCards = (dashboardData) => {
  if (!dashboardData) return [];

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-NG").format(number);
  };

  const formatCurrency = (amount) => {
    return `₦ ${formatNumber(amount)}.00`;
  };

  const activeMemberCount =
    dashboardData.activeMembers !== undefined &&
    dashboardData.activeMembers !== null
      ? dashboardData.activeMembers
      : dashboardData.onboardedMembers;

  return [
    {
      name: "Active Members",
      total:
        activeMemberCount !== undefined && activeMemberCount !== null
          ? formatNumber(activeMemberCount)
          : "0",
      image: "/Images/Dashboard/1.svg",
      bgColor: "#A8E1C8",
      color: "#318C64",
      route: "/super_admin/member_management/members",
    },
    {
      name: "Onboarded Staff",
      total:
        dashboardData.onboardedStaff !== undefined &&
        dashboardData.onboardedStaff !== null
          ? formatNumber(dashboardData.onboardedStaff)
          : "0",
      image: "/Images/Dashboard/1.svg",
      bgColor: "var(--color-secondary-soft)",
      color: "var(--color-secondary)",
      route: "/super_admin/staff_registration/view_staff",
    },
    {
      name: "Total Contribution",
      total: formatCurrency(
        dashboardData.total_contribution ??
          dashboardData.total_contributed ??
          dashboardData.totalContribution ??
          0
      ),
      image: "/Images/Dashboard/1.svg",
      bgColor: "#dafceb",
      color: "#20B16A",
      route: "/super_admin/contribution/contribution_history",
    },
    {
      name: "Total Savings",
      total: formatCurrency(
        dashboardData.total_savings ?? dashboardData.availableSavings ?? 0
      ),
      image: "/Images/Dashboard/2.svg",
      bgColor: "var(--color-primary-soft)",
      color: "var(--color-primary)",
      route: "/super_admin/contribution/contribution_history?category_kind=savings",
    },
    {
      name: "Total Shares",
      total: formatCurrency(dashboardData.total_shares ?? 0),
      image: "/Images/Dashboard/1.svg",
      bgColor: "var(--color-secondary-soft)",
      color: "var(--color-secondary)",
      route: "/super_admin/contribution/contribution_history?category_kind=shares",
    },
    {
      name: "Total Withdrawn",
      total: formatCurrency(dashboardData.totalWithdrawn || 0),
      image: "/Images/Dashboard/2.svg",
      bgColor: "#FCEFE2",
      color: "#DA6900",
      route: "/super_admin/contribution/withdrawal_requests",
    },
    {
      name: "Loan Disbursed",
      total: formatCurrency(dashboardData.loanDisbursed || 0),
      image: "/Images/Dashboard/1.svg",
      bgColor: "var(--color-secondary-soft)",
      color: "var(--color-secondary)",
      route: "/super_admin/loan_management/loan_status",
    },
    {
      name: "Unpaid Loan",
      total: formatCurrency(dashboardData.unpaidLoans || 0),
      image: "/Images/Dashboard/2.svg",
      bgColor: "#FCEFE2",
      color: "#DA6900",
      route: "/super_admin/loan_management/loan_repayment",
    },
  ];
};

export const ViewMemberCards = () => {
  return [
    {
      name: "Personal savings",
      total: "400",
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "#A8E1C8",
      color: "#318C64",
    },
    {
      name: "Contributions",
      total: formatMoney(400 || "0"),
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "var(--color-primary-soft)",
      color: "var(--color-primary)",
    },
    {
      name: "Contributions",
      total: formatMoney(400 || "0"),
      image: "/Members/Icon2.svg",
      percentage: "80%",
      bgColor: "var(--color-secondary-soft)",
      color: "var(--color-secondary)",
    },
  ];
};
export const ViewMemberDashboardCards = () => {
  return [
    {
      name: "Total Contribution made",
      total: formatMoney(400 || "0"),
      image: "/MemberSide/Icons/dashboard1.svg",
      percentage: "80%",
      bgColor: "#A8E1C8",
      color: "#318C64",
    },
    {
      name: "Loan Balance",
      total: formatMoney(400 || "0"),
      image: "/MemberSide/Icons/dashboard2.svg",
      percentage: "80%",
      bgColor: "var(--color-primary-soft)",
      color: "var(--color-primary)",
    },
  ];
};

export const ColorList = [
  "var(--color-primary)",
  "var(--color-secondary)",
  "#318C64",
  "#383838",
  "#6C63FF",
  "#384FFF",
  "#FF4539",
  "#DD3629",
  "#BDA9EE",
  "#FFB9B9",
  "#EB9612",
  "#318C64",
];
